import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { LayoutRoute } from './LayoutRoute';
import { InternalAdminRoute, NonVendorRoute, ProtectedRoute } from './RouteWrappers';
import { PageLoader } from './standaloneRouteHelpers';
import {
  AdminHub,
  AIAnalyticsDashboard,
  AICommunicationEngine,
  AIPredictiveMaintenanceHub,
  AIVendorDispatchIntelligence,
  Alerts,
  AnalyticsAI,
  AnalyticsEnginePage,
  APIPortal,
  BaselineCollection,
  ComingSoon,
  Communications,
  CreateAlert,
  DevTeamAdmin,
  DocumentIntelligenceCenter,
  FeedbackAnalytics,
  FounderCommand,
  IndoorPositioningAdmin,
  InsuranceClaims,
  InsuranceOptimization,
  IntelligenceReporting,
  IoTIntegrationHub,
  LenderRiskAssessment,
  LossControl,
  LossManagement,
  NotFound,
  PrintableSurvey,
  PrintableSurveyFlyer,
  Reports,
  ResolutionCoach,
  RiskMapping,
  Settings,
  SmartOperationsCalendar,
  SuperAdminDashboard,
  SurveysPage,
  TechManagement,
  TenantSurveyPage,
  WaterScorecardPage,
  WhatIfAnalysis,
} from './standaloneRoutePages';

export const ManagementRoutes = () => (
  <>
    <Route
      path="/tech-management"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><TechManagement /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/calendar"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><SmartOperationsCalendar /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/documents"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><DocumentIntelligenceCenter /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/lender-risk-assessment"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><LenderRiskAssessment /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/communications/*"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><Communications /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/alerts"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><Alerts /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/alerts/create"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><CreateAlert /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/losses/*"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><LossManagement /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/loss-control/*"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><LossControl /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/insurance/*"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><InsuranceClaims /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/insurance-optimization/*"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><InsuranceOptimization /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/reports/*"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><Reports /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/internal/water-scorecard"
      element={
        <LayoutRoute>
          <InternalAdminRoute>
            <PageLoader><WaterScorecardPage /></PageLoader>
          </InternalAdminRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/analytics-engine"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><AnalyticsEnginePage /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/risk-mapping"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><RiskMapping /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/settings/*"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><Settings /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/super-admin"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><SuperAdminDashboard /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route path="/admin/indoor-positioning" element={<PageLoader><IndoorPositioningAdmin /></PageLoader>} />
  </>
);

export const AIRoutes = () => (
  <>
    <Route
      path="/analytics-ai"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><AnalyticsAI /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/ai-predictive-maintenance"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><AIPredictiveMaintenanceHub /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/ai-vendor-dispatch"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><AIVendorDispatchIntelligence /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/iot-hub"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><IoTIntegrationHub /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/what-if-analysis"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><WhatIfAnalysis /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/resolution-coach"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><ResolutionCoach /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/intelligence-reporting"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><IntelligenceReporting /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/ai-communication-engine"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><AICommunicationEngine /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/ai-analytics"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><AIAnalyticsDashboard /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/feedback-analytics"
      element={
        <LayoutRoute>
          <ProtectedRoute>
            <PageLoader><FeedbackAnalytics /></PageLoader>
          </ProtectedRoute>
        </LayoutRoute>
      }
    />
  </>
);

export const AdminRoutes = () => (
  <>
    <Route path="/admin" element={<PageLoader><AdminHub /></PageLoader>} />
    <Route path="/admin/dev-portal" element={<PageLoader><DevTeamAdmin /></PageLoader>} />
    <Route path="/admin/baseline-collection" element={<PageLoader><BaselineCollection /></PageLoader>} />
    <Route path="/admin/surveys" element={<PageLoader><SurveysPage /></PageLoader>} />
    <Route
      path="/admin/founder-command/*"
      element={
        <LayoutRoute>
          <PageLoader><FounderCommand /></PageLoader>
        </LayoutRoute>
      }
    />
  </>
);

export const PublicAndFallbackRoutes = () => (
  <>
    <Route path="/survey/maintenance" element={<PageLoader><TenantSurveyPage /></PageLoader>} />
    <Route path="/survey" element={<Navigate to="/survey/maintenance" replace />} />
    <Route path="/survey/tenant" element={<Navigate to="/survey/maintenance" replace />} />
    <Route path="/tenant-survey" element={<Navigate to="/survey/maintenance" replace />} />
    <Route path="/maintenance-survey" element={<Navigate to="/survey/maintenance" replace />} />
    <Route path="/survey/print" element={<PageLoader><PrintableSurvey /></PageLoader>} />
    <Route path="/survey/flyer" element={<PageLoader><PrintableSurveyFlyer /></PageLoader>} />
    <Route
      path="/api-portal"
      element={
        <LayoutRoute>
          <NonVendorRoute>
            <PageLoader><APIPortal /></PageLoader>
          </NonVendorRoute>
        </LayoutRoute>
      }
    />
    <Route
      path="/coming-soon"
      element={
        <LayoutRoute>
          <PageLoader><ComingSoon /></PageLoader>
        </LayoutRoute>
      }
    />
    <Route path="*" element={<PageLoader><NotFound /></PageLoader>} />
  </>
);
